<template>
    <a
        :href="this.$root.baseUrl + '/favorites'"
        data-da=".header__left, 767.98, 1"
        class="actions-header__item header-favorite _icon-hd_favorite"
    >
        <span>{{favoritesIds.complexes.length + favoritesIds.properties.length || 0}}</span>
    </a>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "FavoritesLink",
    computed: {
        ...mapGetters({
            favoritesIds: 'favorites/favoritesIds'
        })
    }
}
</script>
